import { render, staticRenderFns } from "./PetugasBOAktif.vue?vue&type=template&id=325ab928&"
import script from "./PetugasBOAktif.vue?vue&type=script&lang=js&"
export * from "./PetugasBOAktif.vue?vue&type=script&lang=js&"
import style0 from "./PetugasBOAktif.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports